import { CentroCusto } from 'service/api'

export interface INodeCentroCusto extends CentroCusto {
    children?: INodeCentroCusto[]
    codigo: string
    nomeCentroCusto: string
    id: number
}

export function mapearArvore(
    fetchedData: CentroCusto[] = [],
): INodeCentroCusto[] {
    const nodesMapeados: INodeCentroCusto[] = []

    const carregarFilhos = (node: INodeCentroCusto) => {
        const filhos = fetchedData
            ?.filter(item => item.predecessorId === node.id)
            .sort((a, b) => a.codigo.localeCompare(b.codigo))
        if (filhos) {
            node.children = filhos
            filhos.forEach(item => {
                nodesMapeados.push(item)
                carregarFilhos(item)
            })
        }
    }

    const nodes = fetchedData?.map(item => {
        if (item.predecessorId) {
            const predecessor = fetchedData.find(
                n => n.id === item.predecessorId,
            ) as INodeCentroCusto
            if (!predecessor) {
                return { ...item, predecessorId: undefined }
            }
        }
        return item
    })

    return nodes
        ?.filter(item => !item.predecessorId)
        ?.map(item => {
            nodesMapeados.push(item)
            const node = { ...item }
            carregarFilhos(node)
            return node
        })
}

export function mapRenderCentros(data: CentroCusto[] = []) {
    const centrosCustoMapeados = mapearArvore(data)

    function montarArvore(
        node: INodeCentroCusto,
        space = 0,
    ): Array<INodeCentroCusto & { space: number }> {
        return [
            {
                ...node,
                space,
            },
            ...(node.children
                ? node.children.flatMap(child => montarArvore(child, space + 1))
                : []),
        ]
    }

    return centrosCustoMapeados.flatMap(centro => montarArvore(centro, 0))
}
